import { useNavigate } from "react-router-dom";
import logo from "../assets/logos/Logo.svg";

const Error = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen w-full flex-col bg-slate-100">
      <header className="flex h-16 shrink-0 items-center border-b border-slate-200 bg-white px-4 sm:px-6">
        <img src={logo} alt={import.meta.env.VITE_APP_TITLE} className="h-8" />
      </header>

      <main className="flex flex-1 items-center justify-center p-4 sm:p-6">
        <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm sm:p-10">
          <p className="font-Nunito text-6xl font-extrabold tracking-tight text-indigo-600 sm:text-7xl">
            404
          </p>
          <h1 className="mt-3 text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
            Page introuvable
          </h1>
          <p className="mt-2 font-Nunito text-sm text-slate-500">
            La page que vous cherchez n'existe pas ou a été déplacée.
          </p>

          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="mt-6 inline-flex h-11 w-full cursor-pointer items-center justify-center rounded-xl bg-indigo-600 font-Nunito text-sm font-semibold text-white shadow-sm transition-colors hover:bg-indigo-700 focus-visible:ring-2 focus-visible:ring-indigo-300 focus-visible:ring-offset-2 focus-visible:outline-none"
          >
            Retour à l'accueil
          </button>
        </div>
      </main>
    </div>
  );
};

export default Error;
